import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    layersToggleButton: {
      color: '#001D29',
      position: 'relative',
      zIndex: 1000,
      backgroundColor: '#FFFFFF',
      borderRadius: '8px',
      padding: '5px',
      cursor: 'pointer',
      width: '40px',
      height: '40px',
      '&:hover': {
        backgroundColor: '#F5F5F5',
      },
    },
    tooltip: {
      backgroundColor: '#1A1C19',
      color: '#FFFFFF',
      fontSize: '12px',
      padding: '2px 8px',
      borderRadius: '5px',
      border: 'none',
      margin: '8px',
      '&.leaflet-tooltip': {
        padding: '4px 8px',
        backgroundColor: '#FFFFFF',
        '&::before': {
          display: 'none',
        },
      },
    },
  }),
)
